module.exports = __webpack_public_path__ + "img/youtube.1f7d87ca.svg";